import React from "react";
import Link from "gatsby-link";
import styled from "styled-components";

import ExternalLink from "../components/ExternalLink";
import { LinkList, ListItem } from "../components/LinkList";

const Contact = () => (
  <div>
    <Contents>
      <H1>Contact</H1>
      <Text>
        Hi 👋🏼, feel free to contact me somewhere on the web or via mail: post
        @ [this website]
      </Text>
      <LinkList>
        <ListItem>
          <ExternalLink href="https://github.com/jurekbarth">
            Github
          </ExternalLink>
        </ListItem>
        <ListItem>
          <ExternalLink href="https://codepen.io/jurekbarth/">
            Codepen
          </ExternalLink>
        </ListItem>
        <ListItem>
          <ExternalLink href="https://www.xing.com/profile/Jurek_Barth">
            Xing
          </ExternalLink>
        </ListItem>
        <ListItem>
          <ExternalLink href="https://www.linkedin.com/in/jurekbarth/">
            LinkedIn
          </ExternalLink>
        </ListItem>
        <ListItem>
          <ExternalLink href="https://twitter.com/jurekbarth">
            Twitter
          </ExternalLink>
        </ListItem>
        <ListItem>
          <ExternalLink href="https://www.facebook.com/jurek.barth">
            Facebook
          </ExternalLink>
        </ListItem>
        <ListItem>
          <ExternalLink href="https://www.instagram.com/jurekbarth/">
            Instagram
          </ExternalLink>
        </ListItem>
      </LinkList>
    </Contents>
  </div>
);

const Contents = styled.div`
  padding: 0 1em;
  max-width: 30em;
  line-height: 1.6;
`;

const H1 = styled.h1`
  margin: 0;
`;

const Text = styled.p``;

export default Contact;



// WEBPACK FOOTER //
// ./src/pages/contact.js